"use client";

import { useTechnologyData } from "../../hooks/useTechnologyData";
import ProductsList from "./products-list";
import {
  BigBlock,
  ConstructorEnum,
  ImageBlock,
  SmallImageBlock,
  SmallVideoBlock,
  YoutubeBlock,
} from "@/api/generated-api";
import TechnologyYoutube from "./youtube";
import React from "react";
import TechnologySmallImage from "./smallImage";
import TechnologySmallVideo from "./smallVideo";
import TechnologyImage from "./image";
import TechnologyBig from "./big";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const DetailTechnologyContent = () => {
  const { detailTechnology, isLoading } = useTechnologyData();

  if (!detailTechnology || isLoading) return null;

  const renderSection = (item: YoutubeBlock | SmallImageBlock | SmallVideoBlock | BigBlock | ImageBlock) => {
    switch (item.type) {
      case ConstructorEnum.Youtube:
        return <TechnologyYoutube data={item as YoutubeBlock} />;
      case ConstructorEnum.Small:
        return <TechnologySmallImage data={item as SmallImageBlock} />;
      case ConstructorEnum.SmallVideo:
        return <TechnologySmallVideo data={item as SmallVideoBlock} />;
      case ConstructorEnum.Image:
        return <TechnologyImage data={item as ImageBlock} />;
      case ConstructorEnum.Big:
        return <TechnologyBig data={item as BigBlock} />;
      default:
        return null;
    }
  };

  return (
    <Container className={S.wrapper}>
      <section className={S.section}>
        {detailTechnology.blocks.map((item, idx) => (
          <React.Fragment key={idx}>{renderSection(item)}</React.Fragment>
        ))}
      </section>
      <ProductsList />
    </Container>
  );
};

export default DetailTechnologyContent;
